<template>
  <div class="module test-module" :id="moduleData.itemCode" style="padding-bottom: 25px;">
    <div class="module-label">
      测试要求
    </div>
    <el-form class="" :model="form" :rules="rules" ref="form" label-width="165px" label-position="right">
      <el-form-item prop="itemList" label-width="0">
        <el-table :data="form.itemList" border :highlight-current-row="false" class="item-table" v-if="form.itemList.length">
          <el-table-column label="序号" type="index" width="49" cell-style="index-cell" align="center"></el-table-column>
          <el-table-column prop="itemName" label="测试项目" width="270" align="left" class-name="break-spaces-column"></el-table-column>
          <el-table-column prop="standardCode" label="测试标准" width="270" align="left" class-name="break-spaces-column"></el-table-column>
          <el-table-column label="测试备注" width="" align="center">
            <template slot-scope="scope" v-if="configByCode.itemTestMemo">
              <el-input v-model="scope.row.testMemo" :disabled="disabledAll" placeholder="点击填写" :maxlength="configByCode.itemTestMemo.fillLen" type="textarea" autosize resize="none">
                <template #prefix v-if="!disabledAll">
                  <img src="../../../assets/images/apply/edit.png" alt="" style="margin: 14px 0 0 5px">
                </template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="103" align="center" v-if="!disabledAll && !isOiq">
            <template slot-scope="scope">
              <el-button type="text" @click="delItem(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="common-btn" @click="openDialog" style="margin: 0 0 27px;" v-if="!disabledAll">+ 添加测试项目及标准</el-button>
      </el-form-item>
      <template v-if="configByCode.testMemo">
        <div class="memo-label">{{configByCode.testMemo.attrName}}</div>
        <el-input id="myTextarea" type="textarea" :placeholder="configByCode.testMemo.fillNotice" :maxlength="configByCode.testMemo.fillLen" v-model="form.testMemo"
                  :disabled="disabledAll" class="memo-textarea"></el-input>
      </template>
      <template v-if="configByCode.testItem">
        <UploadFile :api-url="host.javaUrl" v-model="form.testMemoImg" v-if="!disabledAll" :limit="configByCode.testItem.fillLen">
          <template #btn>
            <el-button class="upload-btn" :disabled="disabledAll || form.testMemoImg.length >= configByCode.testItem.fillLen">
              <img src="../../../assets/images/apply/upload.png" alt="">
              {{configByCode.testItem.attrName}}
            </el-button>
          </template>
        </UploadFile>
      </template>

      <div class="file-list" v-if="form.testMemoImg.length">
        <div class="file-item" v-for="(item, index) in form.testMemoImg" :key="index">
          <a :href="item.src" target="_blank">{{ item.name }}</a>
          <span class="del-file" @click="delFile(index)" v-if="!disabledAll">删除</span>
        </div>
      </div>
    </el-form>
    <el-dialog title="选择需要测试的套餐或项目" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" class="sample-requirements-dialog" :append-to-body="true">
      <div>
        <span class="type-label">测试标准<span style="color: #FF0000;">*</span></span>
        <el-select v-model="categoryPath" placeholder="请选择" :disabled="disabledAll" style="width: 210px;" @change="categoryChange" :loading="loading">
          <el-option v-for="item in standardData" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
          </el-option>
        </el-select>
      </div>
      <div class="test-check-group">
        <el-checkbox-group v-model="itemIds">
          <template v-if="packageList.length">
            <div class="items-title">选择测试套餐：</div>
            <div v-for="item in packageList" :key="item.itemId" class="test-check-item" style="margin-top: 20px;">
              <el-checkbox :label="item.itemId">常规测试套餐：{{item.itemName.replaceAll('\n', '，')}}</el-checkbox>
            </div>
          </template>
          <template v-if="singleItemList.length">
            <div class="items-title">选择测试单项：</div>
            <div v-for="item in singleItemList" :key="item.itemId" class="test-check-item">
              <el-checkbox :label="item.itemId">{{item.itemName}}</el-checkbox>
              <el-input class="test-memo" type="textarea" v-model="item.testMemo" v-if="item.applyFormCode === 'OTHER'" maxlength="255" resize="none" placeholder="请输入其他测试需求"></el-input>
            </div>
          </template>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import {qryByCategory} from "src/request/apis";
import UploadFile from "src/components/UploadFile/index.vue";
export default {
  name: "TestInfo",
  components: {
    UploadFile
  },
  mixins: [applyMixins],
  data() {
    return {
      form: {
        itemList: [],
        testMemoImg: [],
        testMemo: '',
        categoryPath: ''
      },
      dialogVisible: false,
      loading: false,
      itemIds: [],
      packageList: [],
      singleItemList: [],
      categoryPath: '',
      itemById: {},
      sampleCategory: '',
      configByCode: {}
    }
  },
  computed: {
    rules() {
      return {
        itemList: [this.required]
      }
    },
    standardData() {
      if (this.sampleCategory && this.sampleCategoryByCode[this.sampleCategory]) {
        return this.sampleCategoryByCode[this.sampleCategory].children || []
      }
      return []
    },
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'TestInfo') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
      },
      immediate: true
    },
    enumConfig: {
      handler(val) {
        if (val) {
        }
      },
      immediate: true
    },
    businessInfo: {
      handler(val) {
        // if (val && this.isCreate) this.qryTestItems(val.configId)
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (val) {
          if (this.moduleData.sourceFormatJson) {
            this.form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
        }
      },
      immediate: true
    },
  },
  methods: {
    // 清空选择
    reset(data) {
      const {sampleCategory, isReset} = data
      this.sampleCategory = sampleCategory
      if (isReset) {
        this.form.categoryPath = ''
        this.form.itemList = []
      }
    },
    categoryChange(categoryCode, notClear) {
      if (!notClear) this.itemIds = []
      this.loading = true
      this.singleItemList = []
      this.packageList = []
      qryByCategory({
        businessLineId: this.businessInfo.configId,
        categoryCode,
        labelName: this.sampleCategory
      }, this.host.javaUrl).then(res => {
        this.loading = false
        if (res.resultCode === '0') {
          res.data.items.forEach(v => {
            const i = this.itemIds.indexOf(v.itemId)
            if (notClear && i > -1 && v.applyFormCode === 'OTHER') v.testMemo = this.form.itemList[i].testMemo
            if (v.itemType === 1) {
              this.packageList.push(v)
            } else {
              this.singleItemList.push(v)
            }
            this.itemById[v.itemId] = v
          })
        } else {
          this.$message.error(res.resultMsg)
        }
      }).catch(e => {
        this.loading = false
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.singleItemList = []
      this.packageList = []
    },
    openDialog() {
      if (!this.sampleCategory) {
        this.$message.error('请先选择样品')
        return
      }
      this.dialogVisible = true
      this.categoryPath = this.form.categoryPath
      if (this.form.categoryPath) {
        this.itemIds = this.form.itemList.map(v => v.itemId)
        this.categoryChange(this.form.categoryPath, true)
      }
    },
    delItem(index) {
      this.form.itemList.splice(index, 1)
    },
    delFile(index) {
      this.form.testMemoImg.splice(index, 1)
    },
    handleSubmit() {
      if (!this.categoryPath) {
        this.$message.error('请选择测试标准')
        return
      }
      if (!this.itemIds.length) {
        this.$message.error('请勾选需要的测试套餐/常规测试项目')
        return
      }
      this.form.categoryPath = this.categoryPath
      const currentIds = []
      this.form.itemList = this.form.itemList.filter(v => {
        if (this.itemById[v.itemId].applyFormCode === 'OTHER') {
          v.testMemo = this.itemById[v.itemId].testMemo
        }
        currentIds.push(v.itemId)
        return this.itemIds.includes(v.itemId)
      })
      this.itemIds.forEach(v => {
        if (!currentIds.includes(v)) this.form.itemList.push(JSON.parse(JSON.stringify(this.itemById[v])))
      })
      this.handleClose()
    },
    getValidate() {
      let data = this.form
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(this.form, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => resolve((!this.isSave || !!this.form.itemList.length) || '请添加测试项目及标准'))
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .break-spaces-column .cell {
  white-space: break-spaces;
  padding: 0 10px!important;
}
.test-check-item {
  margin-bottom: 16px;
  width: 100%;
}
.test-group-name {
  font-size: 14px;
  white-space: break-spaces;
  margin-top: 15px;
  padding-left: 26px;
}
.upload-btn {
  width: 150px;
  height: 32px;
  background: linear-gradient(0deg, #EEEEEE, #FFFFFF);
  border: 1px solid #B5B5B5;
  border-radius: 4px;
  padding: 0;
  text-align: center;
  line-height: 30px;
  color: #333333;
  margin-bottom: 20px;

  img {
    vertical-align: text-top;
    margin-right: 4px;
  }
}
.items-title {
  color: rgb(51, 51, 51);
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  margin: 20px 0 15px;
}
.item-table {
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: center;
  .el-button {
    width: 100px;
  }
}
.test-memo {
  margin-left: 24px;
  width: 510px;
  height: 60px;
  margin-top: 16px;
}
.test-check-group {
  max-height: 60vh;
  overflow: auto;

  .el-checkbox {
    display: inline-flex;
    max-width: 100%;
  }
  ::v-deep .el-checkbox__input {
    white-space: normal;
  }
  ::v-deep .el-checkbox__label {
    position: relative;
    top: -2px;
    white-space: normal;
    //white-space: break-spaces;
  }
}
</style>
<style lang="scss">
</style>